export enum FakeDoorType {
  WORLD_CUP = 'WORLD_CUP',
  UNSUPPORTED = 'UNSUPPORTED',
}
